import { useEffect } from "react";
import { getConsent } from "@/components/CookieConsent";

const ADSENSE_ID = process.env.REACT_APP_ADSENSE_PUBLISHER_ID;
const GA4_ID = process.env.REACT_APP_GA4_ID;

// Load external scripts only AFTER the user has given appropriate consent.
// Listens to fincalc:consent:changed so toggling preferences re-checks state.
//
// In dev (no env vars set) this component is inert — ads/analytics stay off.
// In prod, set REACT_APP_ADSENSE_PUBLISHER_ID + REACT_APP_GA4_ID in .env.

function loadOnce(id, src, attrs = {}) {
    if (document.getElementById(id)) return;
    const s = document.createElement("script");
    s.id = id;
    s.src = src;
    s.async = true;
    Object.entries(attrs).forEach(([k, v]) => s.setAttribute(k, v));
    document.head.appendChild(s);
}

function initAdSense() {
    if (!ADSENSE_ID) return;
    loadOnce(
        "adsbygoogle-js",
        `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADSENSE_ID}`,
        { crossorigin: "anonymous" },
    );
}

function initGA4() {
    if (!GA4_ID) return;
    loadOnce("ga4-js", `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`);
    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    window.gtag = gtag;
    gtag("js", new Date());
    gtag("config", GA4_ID, { anonymize_ip: true });
}

export default function ThirdPartyScripts() {
    useEffect(() => {
        const apply = () => {
            const c = getConsent();
            if (!c) return;
            if (c.ads) initAdSense();
            if (c.analytics) initGA4();
        };
        apply();
        window.addEventListener("fincalc:consent:changed", apply);
        return () => window.removeEventListener("fincalc:consent:changed", apply);
    }, []);
    return null;
}
